import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonService } from 'src/services/common.service';
import Swal from 'sweetalert2';
import { EnvService } from '../env.service';
import { environment } from 'src/environments/environment';
import { MDAGENTPROFILEModel, ProvinceModel } from '../app.component';

@Component({
  selector: 'app-Index',
  templateUrl: './Index.component.html',
  styleUrls: ['./Index.component.scss']
})
export class IndexComponent implements OnInit {
  provinces: ProvinceModel[] = [];
  provincesUrl = environment.production === true ? this.env.provincesUrl : environment.provincesUrl;
  
  constructor(private env: EnvService, private commonService: CommonService, private activatedRoute: ActivatedRoute,) {

    this.provincesUrl = this.env.provincesUrl;
    // if(this.activatedRoute?.url?.toString().includes('/report') )
    // {
    //     this.showReport = true;
  
    // }
   }

  ngOnInit() {
    this.getProvinces();
  }
  // changeProvince(area: string, province: string)
  // {
  //   debugger;
  //   if(area?.length > 0)
  //   {
  //     this.areas = this.areaGroup.find(x=>x.area === area).lines;
  //   }
  //   if(province?.length > 0)
  //   {
  //     this.areas =  this.areas.filter(x=>x.province === province);
  //   } 
  // }
  // filterKey(keyword: string)
  // {
    
  //   if(keyword?.length > 0)
  //   {
  //     this.areas =  this.saveAreas.filter(x=>x.province?.toLowerCase().includes(keyword) || x.agentName?.toLowerCase().includes(keyword) || x.area?.toLowerCase().includes(keyword));
  //   }
  //   else
  //   {
  //     this.areas =  this.saveAreas;
  //   }
     
  // }
  isloaded = false;
  register(txtName: string,  txtCompany: string, txtPhone: string, txtBirthDay: string, txtEmail: string, txtSponsor: string,  ddlArea: string,  txtMessage: string)
  {
    // 
    let canAdd = true;

    if(canAdd && (txtName === null || txtName === undefined || txtName === '')  )
    {
      canAdd = false;
      Swal.fire('Thông tin', 'Vui lòng điền tên', 'info'); 
    }
    if(canAdd && (txtCompany === null || txtCompany === undefined || txtCompany === '' ))
    {
      canAdd = false; 
      Swal.fire('Thông tin', 'Vui lòng điền tên công ty', 'info'); 
    }
    if(canAdd && (txtPhone === null || txtPhone === undefined || txtPhone === '' ))
    {
      canAdd = false; 
      Swal.fire('Thông tin', 'Vui lòng điền số điện thoại', 'info'); 
    }
    if(canAdd && (txtEmail === null || txtEmail === undefined || txtEmail === '' ))
    {
      canAdd = false; 
      Swal.fire('Thông tin', 'Vui lòng điền email', 'info'); 
    }
    if(canAdd && (ddlArea === null || ddlArea === undefined || ddlArea === '' ))
    {
      canAdd = false; 
      Swal.fire('Thông tin', 'Vui lòng chọn khu vực', 'info'); 
    }
    let model = new MDAGENTPROFILEModel();
     
    model.agentName = txtName;
    model.areaCode = ddlArea; 
    model.birthday =  txtBirthDay; 
    model.email = txtEmail;
    model.mobilePhone = txtPhone;
    model.customF1 = txtSponsor;
    model.customF2 = txtCompany;
    model.customF3 = txtMessage;

    model.fullAddress = "";
    model.actionBy = "AGW";
    model.createFrom = "AGW";  
    model.host= this.env.host;

    // model.mobilePhone = txtPhone;
    if(canAdd)
    {
      this.isloaded = true;

      this.commonService.RegisAgent(model).subscribe((response: any)=>{
      this.isloaded = false;

        if(response.success)
        {
           Swal.fire('Thành công','Đăng ký thành công. Vui lòng kiểm tra email hoặc liên hệ: 028 3521 9040', 'success');
        }
        else
        {
          Swal.fire('Không thành công',  response.errorMessage, 'warning'); 
        }
      }, error =>{
       this.isloaded = false;

        Swal.fire('Không thành công','Đăng ký không thành công.', 'error'); 
      });
    }
    else
    {
      this.isloaded = false;
    }
    
  }
  getProvinces()
  {
    this.commonService.GetProvinces().subscribe((response: any)=>{
      if(response?.length>0)
      {
        this.provinces = response;
        //  if(provinces?.length > 0)
        //  {
        //   provinces= provinces.filter(x=>x.division_type === "thành phố trung ương" || x.division_type === "thành phố" || x.division_type === "tỉnh" || x.division_type === "quận" || x.division_type === "quận")
        //  }
      }
      else
      {
        Swal.fire({
          icon: 'error', 
          title: 'Get Provinces',
          text:  "Can not connect to System"
        });
      }
    }, error=>{
      Swal.fire({
        icon: 'error', 
        title: 'Get Provinces',
        text:  "Can not connect to System"
      });
    })
  }
}
